import { __decorate, __metadata } from "tslib";
import { MultiEntityTypeEnum } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsOptional } from 'class-validator';
import { BirthdayFieldPolicyEnum, DEFAULT_BIRTHDAY_POLICY, MerchantExposeGroup, StoreExposeGroup } from '../interface';
let PatchMerchantFeaturesFlagsDto = class PatchMerchantFeaturesFlagsDto {
    constructor() {
        this.isAvailableAtEnabled = true;
        this.isCustomerImportEnabled = false;
        this.showDomainManagement = false;
        this.showPrintTagManagement = false;
        this.showDelayPrepTime = false;
        this.showLoyaltyTarget = false;
        this.giftcardsPurchaseEnabled = false;
        this.isGiftCardImportEnabled = false;
        this.isDynamicMenuEnabled = true;
        this.isDelayedOrderValidationEnabled = true;
        this.isOrderThrottlingEnabled = false;
        this.showMultiplePromotionsFlags = false;
        this.isMinMaxRelativeToGrossTotal = false;
        this.isItemBaseGroupEnabled = false;
        this.birthdayField = DEFAULT_BIRTHDAY_POLICY;
        this.multiEntityType = MultiEntityTypeEnum.FRANCHISE;
        this.isVirtualMenuEnabled = false;
        this.isMultiMenuEnabled = false;
        this.isGridLayoutReplicationEnabled = false;
        this.isNotifierRabbitMQEnabled = true;
        this.isCampaignEnabled = false;
        this.isVonageNumberVerified = false;
        this.showMarketingSubscription = true;
        this.isItemWeightEnabled = false;
        this.isItemPrepTimeEnabled = false;
        this.disableSendEmailLoginCode = false;
        this.isCustomerSharingDisabled = true;
        this.isMobileMerchant = false;
        this.isFranchiseMarketingEnabled = false;
        this.isComboGroupsTabEnabled = false;
        this.alwaysDisplayTimedMenu = false;
        this.isDiningOptionsMenuEnabled = false;
        this.sendRefundReceipt = false;
        this.isOperationalSmsToPush = false;
        this.isLocationGroupsEnabled = false;
        this.isFranchiseInviteEnabled = false;
        this.isNewCheckoutFlowEnabled = false;
        this.isNewPaymentPageEnabled = false;
        this.isGiftCardReconciliationEnabled = false;
        this.isTemplateSubscriptionEnabled = false;
        this.isFranchiseDirectoryEnabled = true;
        this.isDiscountAvailabilityTimeOrchestrationEnabled = true;
        this.isGiftCardEmailReportEnabled = false;
        this.isCustomerChangeBirthdayRestrictionDisabled = false;
    }
};
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true, description: 'Enable/Disable availableAt' }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isAvailableAtEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isCustomerImportEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "showDomainManagement", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "showPrintTagManagement", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "showLoyaltyManagement", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "showDelayPrepTime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "showLoyaltyTarget", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "giftcardsEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "giftcardsPurchaseEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isGiftCardImportEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isDynamicMenuEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isDelayedOrderValidationEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isOrderThrottlingEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "showMultiplePromotionsFlags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isMinMaxRelativeToGrossTotal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isItemBaseGroupEnabled", void 0);
__decorate([
    ApiPropertyOptional({ enum: BirthdayFieldPolicyEnum, default: DEFAULT_BIRTHDAY_POLICY }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsEnum(BirthdayFieldPolicyEnum, { groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchMerchantFeaturesFlagsDto.prototype, "birthdayField", void 0);
__decorate([
    ApiPropertyOptional({ enum: MultiEntityTypeEnum, default: MultiEntityTypeEnum.FRANCHISE }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsEnum(MultiEntityTypeEnum, { groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchMerchantFeaturesFlagsDto.prototype, "multiEntityType", void 0);
__decorate([
    ApiPropertyOptional({ type: Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isVirtualMenuEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isMultiMenuEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isGridLayoutReplicationEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isNotifierRabbitMQEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isCampaignEnabled", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => Boolean,
        default: false,
        description: 'Flag if number was verified by vonage and is able to send marketing sms campaigns.',
    }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isVonageNumberVerified", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "showMarketingSubscription", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isItemWeightEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isItemPrepTimeEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "disableSendEmailLoginCode", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isCustomerSharingDisabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isMobileMerchant", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isFranchiseMarketingEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isComboGroupsTabEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "alwaysDisplayTimedMenu", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isDiningOptionsMenuEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "sendRefundReceipt", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Send push notification if order was made from app' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isOperationalSmsToPush", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Enable location groups' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isLocationGroupsEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Enable franchise invite flow' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isFranchiseInviteEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Use to enable the new checkout flow' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isNewCheckoutFlowEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Use to enable the new payment page' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isNewPaymentPageEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'Use to enable the guest checkout on the new checkout page' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isGuestCheckoutEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'Enable automatic creation and update of Square Loyalty Program' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isCrossMerchantLoyaltySetupEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Enable Gift Card reconciliation' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isGiftCardReconciliationEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Enable Template subscription' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isTemplateSubscriptionEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'Enable automatic orchestration of Square Coupons' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isCrossMerchantDiscountSetupEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'Enables native Combo functionality' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isNativeComboEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'Disables the 1st party Gift Card features' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "usesThirdPartyGiftCardProvider", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true, description: 'Enables franchise directory' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isFranchiseDirectoryEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true, description: 'Enables orchestration of discount availability time' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isDiscountAvailabilityTimeOrchestrationEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Enables franchise GC reporting sent to franchisee emails' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isGiftCardEmailReportEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Use to disable the customer birthday one time change restriction' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchMerchantFeaturesFlagsDto.prototype, "isCustomerChangeBirthdayRestrictionDisabled", void 0);
PatchMerchantFeaturesFlagsDto = __decorate([
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.PATCH, MerchantExposeGroup.UPDATE] })
], PatchMerchantFeaturesFlagsDto);
export { PatchMerchantFeaturesFlagsDto };
//# sourceMappingURL=PatchMerchantFeaturesFlagsDto.js.map